export default {
      id: "ElectricityIcon-usage",
      viewBox: "0 0 432.4 432.4",
      url: __webpack_public_path__ + "sprites/icons.37de8d72.svg#ElectricityIcon",
      toString: function () {
        return this.url;
      }
    }